import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  colorPrimary: {
    color: idsTokens.checkbox.default.color.control.border.enabled,
    borderRadius: 0,
    padding: 'unset',
    height: idsTokens.checkbox.default.sizing.control.standard.height,
    alignItems: 'center',
    paddingTop: `calc((${idsTokens.checkbox.default.sizing.control.standard.height}-${idsTokens.checkbox.default.sizing.control.container.height})/2)`,
    paddingBottom: `calc((${idsTokens.checkbox.default.sizing.control.standard.height}-${idsTokens.checkbox.default.sizing.control.container.height})/2)`,
    '& .MuiSvgIcon-root': {
      width: 24,
      height: 24,
      boxSizing: 'border-box',
    },
    '&.Mui-checked svg': {
      fill: idsTokens.checkbox.default.color.control.background.selected.enabled,
    },
    '&.MuiCheckbox-indeterminate svg': {
      fill: idsTokens.checkbox.default.color.control.background.selected.enabled,
    },
    '&.Mui-checked.Mui-disabled, &.MuiCheckbox-indeterminate&.Mui-disabled': {
      color: idsTokens.checkbox.default.color.control.background.selected.disabled,
    },
    '&.Mui-disabled': {
      '&:not(.Mui-checked, .MuiCheckbox-indeterminate) svg': {
        fill: idsTokens.checkbox.default.color.control.border.disabled,
        '& rect': {
          fill: idsTokens.checkbox.default.color.control.background.unselected.disabled,
        },
      },
      '&.MuiCheckbox-indeterminate svg': {
        fill: idsTokens.checkbox.default.color.control.background.selected.disabled,
      },
      '&.Mui-checked svg': {
        fill: idsTokens.checkbox.default.color.control.background.selected.disabled,
      },
      opacity: 1,
    },
  },
});
